import Links from '@/shared/constants/navegacao';
import MyContext from '@/shared/contexts/AppContext';
import { GetAuthMe } from '@/modules/system/usuario/usuario.service';
import {
  Logar,
  completeInternalSessionFromAuthMe,
} from '@/modules/system/auth/application/auth.service';
import {
  isValidLoginInput,
  normalizeLoginInput,
} from '@/modules/system/auth/application/login-input.utils';
import { toast } from 'react-toastify';
import { useNavigate, Link } from 'react-router-dom';
import { useRef, useContext } from 'react';

export default function LoginTradicional() {
  const loginRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();

  const context = useContext(MyContext);
  if (!context)
    throw new Error('LoginTradicional deve ser usado dentro de um MyProvider');

  const { state, setState } = context;

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const loginRaw = loginRef.current?.value?.trim();
    const password = passwordRef.current?.value;

    if (!loginRaw || !password) {
      toast.warn('Preencha todos os campos.');
      return;
    }

    if (!isValidLoginInput(loginRaw)) {
      toast.warn('Informe um CPF válido ou e-mail institucional.');
      return;
    }

    const login = normalizeLoginInput(loginRaw);

    try {
      await Logar(login, password);
      const me = await GetAuthMe();
      const { sessionPatch } = completeInternalSessionFromAuthMe(me);

      setState({
        ...state,
        ...sessionPatch,
        navbar: true,
      });

      navigate(Links.Index);
    } catch (error) {
      toast.error(String(error));
    }
  };

  return (
    <form className="signin-form" onSubmit={handleSubmit} method="post">
      <div className="loginform-group mb-3">
        <label htmlFor="login" className="loginlabel">
          CPF ou e-mail institucional
        </label>
        <input
          ref={loginRef}
          id="login"
          name="login"
          type="text"
          className="form-control"
          autoComplete="username"
          title="CPF ou e-mail institucional"
          required
        />
      </div>

      <div className="loginform-group mb-4">
        <label htmlFor="password" className="loginlabel">
          Senha
        </label>
        <input
          ref={passwordRef}
          id="password"
          name="password"
          type="password"
          className="form-control"
          autoComplete="off"
          title="Senha"
          required
        />
      </div>

      <div className="loginform-group">
        <button id="acessar"
          type="submit"
          className="form-control loginbtn loginbtn-primary submit px-3"
        >
          Acessar
        </button>
      </div>

      <div className="loginform-group d-md-flex">
        <div className="text-md-right">
          <Link to={Links.Recuperar} title="Esqueceu a senha?">
            Esqueceu sua senha.
          </Link>
          <Link
            to={Links.Auth_Obter_Token}
            className="ms-4"
            title="Quer receber um token para acesso?"
          >
            Login por token.
          </Link>
        </div>
      </div>
    </form>
  );
}
